import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_ORGANIZATION_AVAILABLE_CURRENCIES_PATH,
  type GetAvailableCurrenciesErrorDto,
  type GetAvailableCurrenciesSuccessDto,
} from '@/api/rest/resources/types/organization';

/**
 * Fetches available currencies for the organization
 * @returns Query result containing available currencies with conversion rates
 */
export const useGetAvailableCurrencies = () => {
  return useSuspenseQuery<GetAvailableCurrenciesSuccessDto, GetAvailableCurrenciesErrorDto>({
    queryKey: ['organization', 'available_currencies'],
    queryFn: () => getRequest<GetAvailableCurrenciesSuccessDto>(GET_ORGANIZATION_AVAILABLE_CURRENCIES_PATH),
    staleTime: 1000 * 60 * 5,
  });
};
